/**
 * 自定义标签
 */
import requestByGateway from '@/request/request.gateway';

import qs from 'qs';
import config from '@/config';

const customTag = {
	/**
	 *
	 * 用户_标签_获取标签列表
	 */
	getSearchlabel(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/label/list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户_标签_添加标签或更新
	 */
	getAddlabel(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/label/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户_标签_获取标签详情
	 */
	getDetailslabel(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/label`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户_标签_删除标签
	 */
	getDellabel(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/label/del`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户_标签_删除绑定关系
	 */
	getDelBindlabel(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/label-bind/del`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户标签_获取标签绑定列表
	 */
	getlabelBound(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/label-bind/list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户标签_搜索学生
	 */
	getStudentSearch(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/student/search`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户标签_搜索家长
	 */
	getParentSearch(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/parent/search`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户标签_搜索老师
	 */
	getTeacherSearch(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/teacher/search`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户标签_绑定单个标签
	 */
	getAddlabelbind(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/label-bind/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 *
	 * 用户标签_批量绑定标签
	 */
	getBatch(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/console/v1/label-bind/batch`,
			// headers: config.headers,
			headers: {
				'Content-Type': 'application/json'
			},
			data
		});
	}
	/**
	 *
	 * 用户标签_删除绑定关系
	 */
};

export default customTag;
